document.addEventListener('DOMContentLoaded', function () {
  const currentPath = window.location.pathname

  document.querySelectorAll('a[href*="rw.rw"]').forEach(function (link) {
    const rawHref = link.getAttribute('href')

    if (!rawHref) return

    const url = new URL(rawHref, window.location.origin)

    if (!url.searchParams.has('originpath')) {
      url.searchParams.set('originpath', currentPath)
      link.href = url.toString()
    }
  })
})
